<template>
  <div class="mod-rm__courseclassroomrela">
    <div class="pkg-search-box">
      <el-form class="pkg-content"
               :inline="false"
               :model="dataForm"
               @keyup.enter.native="queryCourse()"
               label-position="left"
               label-width="auto">
        <!--查询条件 第一行-->
        <el-row class="margb10 pkg-search-condition">
          <el-col :span="7">
            <!-- 课程编号 -->
            <el-form-item class="one-course" prop="coursecName">
              <span slot="label">
                <el-link type="primary" :underline="false" @click="selectCourse">{{$t('res.courseclassroomrela.courseNumber')}}</el-link>
              </span>
              <div class="el-input el-input--default el-input__inner" style="height:30px;" @mouseenter="courseShow()" @mouseleave="courseLeave()" >
                <div style="width:70%;float:left;" class="holder" contenteditable="false" :placeholder="$t('cert.selectTips')">{{this.dataForm.coursecName}}</div>
                <el-link type="primary" :underline="false" class="el-icon-error link-delete-temp" ref="trainerLabelLink" v-show="courseShowFlg && dataForm.coursecName != '' && dataForm.coursecName != null" style="float:right;margin-top:9px;color:rgba(0,0,0,.3);" @click="celarCourseName()"></el-link>
              </div>
            </el-form-item>
          </el-col>
          <!-- 课程分类 -->
          <el-col :span="7">
            <el-form-item class="one-sortingclasses" :label="$t('res.courseclassroomrela.courseClassId')">
              <catalogtree @cateloglist="cateloglist"
                          :defaultProps="defaultPropsz"
                          :showArray="showCourseClassList"
                          :showValue="showValue"
                          :url="queryTreeUrl"
                          :isSelect=false
                          :status="'classStatus'"
                          ref="catalogtreeList"></catalogtree>
            </el-form-item>
          </el-col>
          <!-- 团队分类 -->
          <el-col :span="7">
            <div style="width:100%; display:flex">
              <div class="one-courseteamclassification-div" style="width:80%">
                <el-form-item prop="courseTeamCatalogFirst"
                            style="width:100% !important"
                            :label="$t('res.courseclassroomrela.courseTeamCatalog')">
                  <div class="box01"
                      style="width: auto; float: left;">
                    <el-select v-model="dataForm.courseTeamCatalogFirst"
                              :placeholder="$t('cert.selectTips')"
                              @change="getcourseTeamCatalog($event)"
                              clearable>
                      <el-option v-for="item in select1"
                                :key="item.code"
                                :label="item.name"
                                :value="item.code">
                      </el-option>
                    </el-select>
                  </div>
                </el-form-item>
              </div>
              <div style="width:32%;margin-left:3px;" class="courseTeamCatalogSecondSel">
                <div class="box02" style="width: 60%; float: left;">
                  <el-select v-model="dataForm.selectCatalogSecond"
                            :placeholder="$t('cert.selectTips')"
                            @change="getList($event)"
                            clearable>
                    <el-option v-for="item in select2"
                              :key="item.code"
                              :label="item.name"
                              :value="item.code"></el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="3"
                  class="query-button">
            <!-- 查询按钮 -->
            <el-col :span="24">
              <!--查询按钮-->
              <el-button class="M-search"
                         style="margin-bottom: 7px"
                         type="primary"
                         v-if="$hasPermission('AUTHRELACLASSROOM0001')"
                         @click="queryCourse">{{ $t('query') }}</el-button>
            </el-col>
          </el-col>
        </el-row>
        <!--查询条件 第二行-->
        <el-row class="margb10 pkg-search-condition">
          <el-col :span="7">
            <!-- 教室编号 -->
            <el-form-item class="tow-classroom" :label="$t('res.courseclassroomrela.classroom')">
              <el-input v-model="dataForm.classroomNo"
                        clearable
                        :placeholder="$t('res.courseclassroomrela.classroomPlaceholder')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <!-- 教室分类 -->
            <el-form-item class="two-sortingclassroom" prop="classroominfoList"
                          :label="$t('res.courseclassroomrela.classroomClass')">
              <class-tree ref="classroomclassRef"
                          v-on:getSelectList="getClassroomList"
                          v-bind:defaultProps="classroomProps"
                          v-bind:url="queryclassroomUrl"
                          v-bind:isSelect=false
                          :status="dataForm.classRoomStatus"
                          style="width:99%;"></class-tree>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <!-- 课程状态 -->
            <el-form-item class="two-classstatus" :label="$t('res.courseclassroomrela.coursesSatus')" prop="courseStatusArr">
              <el-select multiple
                        collapse-tags
                        v-model="dataForms.courseStatusArr">
                <el-option v-for="(item,index) in newcoursestatus"
                          :key="index"
                          :label="item.name"
                          :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 重置按钮 -->
          <el-col :span="3"
                  class="query-button">
            <el-col :span="24">
              <el-button class="el-back M-search M-margin-l"
                         type="info"
                         v-if="$hasPermission('AUTHRELACLASSROOM0001')"
                         @click="resetQuery()">{{ $t('reset') }}</el-button>
            </el-col>
          </el-col>
        </el-row>
        <!--查询条件 第三行-->
        <div v-show="moreList">
          <el-row class="margb10 pkg-search-condition">
            <el-col :span="7">
              <!-- 教室状态 -->
              <el-form-item class="three-classroomstatus" :label="$t('res.courseclassroomrela.classStatus')" prop="classRoomStatusArr">
                <el-select multiple
                          collapse-tags
                          v-model="dataForms.classRoomStatusArr">
                  <el-option v-for="(item,index) in statusArr"
                            :key="index"
                            :label="item.name"
                            :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <!--所属城市-->
              <el-form-item class="three-city" :label="$t('res.courseclassroomrela.city')" prop="cityList">
                <class-tree ref="cityclassRef"
                            v-on:getSelectList="getCitySelectList"
                            v-bind:defaultProps="citydefaultProps"
                            v-bind:isOpen=false
                            v-bind:url="queryCityTreeUrl"
                            v-bind:isSelect=false></class-tree>
              </el-form-item>
            </el-col>
            <!--所属场地-->
            <el-col :span="7">
              <el-form-item class="search-item three-venue" style="height: 34px;">
                <span slot="label">
                  <el-link type="primary" :underline="false" slot="reference"
                            @click.native.prevent="showSuboSiteDlg">{{ $t('res.courseclassroomrela.classification')}}</el-link>
                </span>
                <div class="el-input el-input--default el-input__inner" style="height:30px;" @mouseenter="templateNameLinkShow()" @mouseleave="templateNameLinkLeave()" >
                  <div style="width:80%;float:left;" class="holder" contenteditable="false" :placeholder="$t('cert.selectTips')">{{this.dataForm.subordinateSiteName}}</div>
                  <el-link type="primary" :underline="false" class="el-icon-error link-delete-temp" ref="templateNameLink" v-show="templateNameLinkShowFlg && dataForm.subordinateSiteName != '' && dataForm.subordinateSiteName != null" style="float:right;margin-top:9px;color:rgba(0,0,0,.3);" @click="clearTemplateName()"></el-link>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <!--查询条件 第四行-->
          <el-row class="margb10 pkg-search-condition">
            <!-- 教室标签 -->
            <el-col :span="7">
              <el-form-item class="search-item four-classroomlabel" style="height: 34px;">
                <span slot="label">
                  <el-link type="primary" :underline="false" slot="reference"
                            @click.native.prevent="showSuboLableDlg">{{ $t('res.courseclassroomrela.classroomLabel')}}</el-link>
                </span>
                <div class="el-input el-input--default el-input__inner" style="height:30px;" @mouseenter="classroomLabelShow()" @mouseleave="classroomLabelLeave()" >
                  <div style="width:80%;float:left;" class="holder" contenteditable="false" :placeholder="$t('cert.selectTips')">{{this.dataForm.classroomLabelName}}</div>
                  <el-link type="primary" :underline="false" class="el-icon-error link-delete-temp" ref="classroomLabelLink" v-show="classroomLabelShowFlg && dataForm.classroomLabelName != '' && dataForm.classroomLabelName != null" style="float:right;margin-top:9px;color:rgba(0,0,0,.3);" @click="clearclassroomLabelName()"></el-link>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <!-- 展开or收起 -->
      <el-row style="text-align: center; margin-bottom: 10px;">
        <el-col :span="24">
          <div class="show-or-hide-icon"
              v-bind:class="{ 'el-icon-arrow-up': moreList,
                                      'el-icon-arrow-down': !moreList }"
              @click="moreList = !moreList">&nbsp;{{ moreList ? $t('common.hide') : $t('res.courseclassroomrela.advancedSearch') }}
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="pkg-content">
      <!-- 按钮 -->
      <div class="search">
        <el-button type="primary"
                  v-if="$hasPermission('AUTHRELACLASSROOM0002')"
                  @click="addUpdate()">{{ $t('res.courseclassroomrela.addRela') }}</el-button>
        <el-button type="primary"
                  v-if="$hasPermission('AUTHRELACLASSROOM0005')"
                  @click="exportAnnualTarget()">{{ $t('res.courseclassroomrela.download') }}</el-button>
        <el-button type="primary"
                  v-if="$hasPermission('AUTHRELACLASSROOM0005')"
                  @click="importRelaDialog()">{{ $t('res.courseclassroomrela.import') }}</el-button>
        <el-button type="primary"
                  v-if="$hasPermission('AUTHRELACLASSROOM0003')"
                  @click="columnBtn()">{{ $t('res.courseclassroomrela.export') }}</el-button>
        <el-button type="primary"
                  v-if="$hasPermission('AUTHRELACLASSROOM0006')"
                  @click="BatchDeletion">{{ $t('res.courseclassroomrela.batchDeletion') }}</el-button>
      </div>
      <el-table :data="dataList"
                border
                ref="selectCourseinfo"
                v-loading="dataListLoading"
                :row-style="{height:48+'px'}"
                :cell-style="{padding:0+'px'}"
                @selection-change="selectionChangeHandle"
                style="width: 100%;">
        <el-table-column type="selection"
                         header-align="center"
                         align="center"
                         width="50">
        </el-table-column>
        <!-- 关系ID -->
        <el-table-column prop="id"
                         header-align="center"
                         v-if="false"
                         align="center"
                         :label="$t('res.courseclassroomrela.courseNo')">
        </el-table-column>
        <!-- 课程ID -->
        <el-table-column prop="courseId"
                         header-align="center"
                         v-if="false"
                         align="center"
                         :label="$t('res.courseclassroomrela.courseNo')">
        </el-table-column>
        <!-- 教室ID -->
        <el-table-column prop="classroomId"
                         header-align="center"
                         v-if="false"
                         align="center"
                         :label="$t('res.courseclassroomrela.courseNo')">
        </el-table-column>
        <!-- 课程编号 -->
        <el-table-column prop="courseNo"
                         header-align="center"
                         align="center"
                         width="150"
                         show-overflow-tooltip
                         :label="$t('res.courseclassroomrela.courseNo')">
        </el-table-column>
        <!-- 课程名称 -->
        <el-table-column prop="coursecName"
                         header-align="center"
                         align="center"
                         :width="160"
                         show-overflow-tooltip
                         :label="$t('res.courseclassroomrela.courseName')">
        </el-table-column>
        <!-- 课程团队分类 -->
        <el-table-column prop="teamcName"
                         header-align="center"
                         align="center"
                         :width="165"
                         :formatter="courseTeamCatalogFormatter"
                         show-overflow-tooltip
                         :label="$t('res.courseclassroomrela.courseTeamClassification')">
        </el-table-column>
        <!-- 课程状态 -->
        <el-table-column prop="courseStatus"
                         header-align="center"
                         align="center"
                         :width="100"
                         :formatter="courseStatusFormatter"
                         :label="$t('res.courseclassroomrela.coursesSatus')">
        </el-table-column>
        <!-- 教室编号 -->
        <el-table-column prop="classroomNo"
                         header-align="center"
                         align="center"
                         width="100"
                         show-overflow-tooltip
                         :label="$t('res.courseclassroomrela.classroomNo')">
        </el-table-column>
        <!-- 教室名称 -->
        <el-table-column prop="classroomName"
                         header-align="center"
                         align="center"
                         :width="160"
                         show-overflow-tooltip
                         :label="$t('res.courseclassroomrela.classroomName')">
        </el-table-column>
        <!-- 教室分类 -->
        <el-table-column prop="classroomClass"
                         header-align="center"
                         align="center"
                         show-overflow-tooltip
                         :label="$t('res.courseclassroomrela.classroomClass')">
        </el-table-column>
        <!-- 所属城市 -->
        <el-table-column prop="city"
                         header-align="center"
                         align="center"
                         show-overflow-tooltip
                         :label="$t('res.courseclassroomrela.city')">
        </el-table-column>
        <!-- 所属场地 -->
        <el-table-column prop="classification"
                         header-align="center"
                         align="center"
                         show-overflow-tooltip
                         :label="$t('res.courseclassroomrela.classification')">
        </el-table-column>
        <!-- 教室状态 -->
        <el-table-column prop="classStatus"
                         :formatter="statusFormatter"
                         header-align="center"
                         align="center"
                         :width="100"
                         :label="$t('res.courseclassroomrela.classStatus')">
        </el-table-column>
        <!-- 教室标签 -->
        <el-table-column prop="classroomTag"
                         header-align="center"
                         align="center"
                         show-overflow-tooltip
                         :label="$t('res.courseclassroomrela.classroomTag')">
          <template slot-scope="scope">
            <span class="el-dropdown-link"
                  v-if="scope.row.numberLaber !== null"
                  @click="checkLable(scope.row)">{{ $t('view') }}</span>
          </template>
        </el-table-column>
        <!-- 优先级 -->
        <el-table-column prop="priority"
                         align="center"
                         :width="130"
                         :label="$t('res.courseclassroomrela.priority')">
          <template slot-scope="scope">
            <div style="line-height: 34px;">
              <!-- 被覆盖之后抢回来 -->
              <el-select v-model="scope.row.priority"
                         class="table-priority-select"
                         :disabled="!$hasPermission('AUTHRELACLASSROOM0004')"
                         @change="editPriority(scope.row)">
                <el-option v-for="(item,index) in priorityArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>
        <!-- 教室池 -->
        <el-table-column prop="sort"
                         header-align="center"
                         align="center"
                         show-overflow-tooltip
                         :label="$t('res.courseclassroomrela.poolName')">
        </el-table-column>
        <el-table-column fixed="right"
                         align="center"
                         width="150"
                         :label="$t('handle')">
          <template slot-scope="scope">
            <div>
              <span class="el-dropdown-link" @click="Update(scope.row)" v-if="$hasPermission('AUTHRELACLASSROOM0001')">{{ $t('view') }}</span>
              <div class="pkg-vertical-divider"></div>
              <el-dropdown trigger="click"
                          placement="bottom">
                <span class="el-dropdown-link">
                  {{ $t('handle') }}<em class="el-icon-caret-bottom el-icon--right"></em>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="courseClassroomRelaDelete(scope.row)" v-if="$hasPermission('AUTHRELACLASSROOM0006')">{{ $t('delete') }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination @size-change="pageSizeChangeHandle"
                     @current-change="pageCurrentChangeHandle"
                     :current-page="page"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="limit"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="total">
      </el-pagination>
      <!--课程与教室关系导入-->
      <import-excel v-bind:visible="importDialog"
                    v-bind:url="importUrl"
                    v-on:closeDialogImport="closeDialogImport"></import-excel>
      <!-- 所属场地dialog -->
    <subordinate-site ref="suborSiteRef"
                      :isSingleElection='false'
                      :isShow='false'
                      :isQueryShow="true"
                      v-bind:selectTable="selectTable"
                      v-bind:statusList="statusList"
                      :dialogVisible="isShowSuboSite"
                      v-on:closeSuboSiteDlg="closeSuboSiteDlg"
                      v-on:bringBack="bringBack"></subordinate-site>
      <!--标签查询条件-->
      <el-dialog title="选择标签"
                 :visible="isQueryShowLable"
                 width="70%"
                 :before-close="showQueryLableClose">
        <el-form label-position="top"
                 label-width="150px"
                 :ref="dataForm">
          <div>
            <el-row>
              <el-col :span="24">
                <el-form-item prop="tagName"
                              style="width: 100%!important;">
                  <tag :checkedList="checkList"
                       :moduleId="moduleId"
                       :overLabelShow = "true"
                       :closeShow = "true"
                       :bussinessTypeId = "bussinessTypeId"
                       :brandCode="bussinessTypeChecked"
                       @getBussinessType="getBussinessType"
                       @changeCheckedList="changeCheckedList"
                       ref='tagTree'
                       @fatherMethod="fatherMethod"></tag>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
        <div>
          <el-button type="primary"
                     @click="onOkLable">{{ $t('res.rela.determine') }}</el-button>
        </div>
      </el-dialog>
      <!-- 标签查看 -->
      <el-dialog title="标签查看"
                 :visible="isShowLable"
                 width="70%"
                 :before-close="showLableClose">
        <el-form label-position="top"
                 label-width="150px"
                 :ref="dataForm">
          <div>
            <el-row>
              <el-col :span="24">
                <el-form-item prop="tagName"
                              style="width: 100%!important;">
                  <tag :checkedList="showcheckList"
                       :moduleId="moduleId"
                       :overLabelShow = "false"
                       :closeShow = "false"
                       :bussinessTypeId = "bussinessTypeId"
                       :brandCode="bussinessTypeChecked"
                       @getBussinessType="getBussinessType"
                       @changeCheckedList="changeShowCheckedList"
                       ref='tagTree'
                       @fatherMethod="fatherMethod"></tag>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </el-dialog>
      <!-- 课程查询 -->
      <el-dialog :title="$t('res.courseclassroomrela.alternativeCourse')"
                :modal="false" width="90%"
                :visible.sync="courseSelect"
                :show-close="false"
                @close="closeFun">
          <selCertCourse @couronOk="couronOk"
                        ref="selCertCourseDialog"
                        :teamPerms="teamPerms"
                        :courseInfoList="courseInfoList"></selCertCourse>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import ClassTree from '@/components/rm/class-tree/index'
import mixinViewModule from '@/mixins/view-module'
import Vue from 'vue'
import importExcel from '@/components/rm/import-excel/index'
import subordinateSite from '@/components/rm/resources-site/index'
import catalogtree from '../learning/common/catalogtree'
import Tag from '@/components/rm/label-select/index'
import selCertCourse from '@/components/rm/course-rela-multiple/index'
import VueI18n from '@/i18n'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/rm/courseclassroomrela/queryRelaList',
        getDataListIsPage: true,
        deleteURL: '/rm/courseclassroomrela/delete',
        deleteIsBatch: true,
        exportURL: '/rm/courseclassroomrela/export'
      },
      dataForm: {
        courseNo: '',
        coursecName: '',
        classroomNo: '',
        classroomName: '',
        classRoomStatus: '',
        courseStatus: '',
        courseClassList: '',
        classroomLabel: '',
        classroomLabelName: '',
        teamClassList: [],
        classroominfoList: [],
        cityList: [],
        classificationList: [],
        subordinateSiteName: '',
        subordinateSiteId: '',
        courseTeamCatalogFirst: '',
        courseTeamCatalogSecond: '',
        selectCatalogSecond: ''
      },
      dataForms: {
        classRoomStatusArr: [],
        courseStatus: [],
        classificationListArr: []
      },
      isQueryShowLable: false,
      isShowLable: false,
      checkList: [],
      showcheckList: [],
      // 模块id，20 代表组织管理模块
      moduleId: '20',
      bussinessTypeId: 10,
      bussinessTypeChecked: 10,
      moreList: false,
      isShowSuboSite: false,
      dataList: [],
      selectTable: [],
      statusList: ['10'],
      dataListLoading: false,
      statusArr: this.enums['status'], // 状态下拉框
      priorityArr: this.enums['priority'], // 优先级,
      templateNameLinkShowFlg: false,
      classroomLabelShowFlg: false,
      courseShowFlg: false,
      // 课程状态
      newcoursestatus: this.enums['courseStatus'],
      siteInfoArr: [
        { code: '112', name: '东莞庆宝' },
        { code: '113', name: '艾仕得成都培训中心' },
        { code: '114', name: '东营广宝' },
        { code: '115', name: '北京培训中心（新）' },
        { code: '116', name: '郑州培训基地' },
        { code: '117', name: '测试场地001' }
      ],// 所属场地
      classroomLabelList: [],
      // 课程与教室关系导入
      importDialog: false,
      // 课程与教室关系导入接口路径
      importUrl: '/rm/courseclassroomrela/importCourseClassroomRelaExcel',
      // 团队分类
      teamProps: {
        children: 'children',
        label: 'treamCnName'
      },
      queryTeamUrl: '/rm/courseclassroomrela/treamClassTreeRela',
      // 课程分类树
      CourseProps: {
        children: 'children',
        label: 'classCname'
      },
      queryCourseUrl: '/rm/courseclassroomrela/courseClassTreeRela',
      // 教室分类
      classroomProps: {
        children: 'children',
        label: 'roomClassCnName'
      },
      queryclassroomUrl: '/rm/courseclassroomrela/courseClassroomTreeRela',
      // 城市分类
      citydefaultProps: {
        children: 'childrenRegionList',
        label: 'regionNameCn'
      },
      queryCityTreeUrl: '/rm/courseclassroomrela/queryregiontree',
      // 课程分类树
      defaultPropsz: {
        children: 'children',
        label: 'catalogNameCn',
        id: 'catalogId'
      },
      // 标签树
      commLabelProps: {
        children: 'children',
        label: 'labelNameCn'
      },
      querycommLabelUrl: '/rm/courseclassroomrela/queryCommLabelNodeByNameRela',
      showCourseClassList: [],
      showValue: '',
      queryTreeUrl: '/learning/coursecatalog/list',
      // 课程团队分类数据 Start
      teamcatalogfirst: this.enums['catalogidList1'],
      select1: [],
      loading: false,
      select2: [],
      allteamcatalog: [],
      teamcatalogsecond: this.enums['catalogidList2'],
      isteamPerm: true,
      teamPerms: 'CLASSROOMTEAM',
      // 课程团队分类数据 End
      courseSelect: false,
      courseInfoList: []
    }
  },
  components: {
    Tag,
    selCertCourse,
    'class-tree': ClassTree,
    'import-excel': importExcel,
    'subordinate-site': subordinateSite,
    'catalogtree': catalogtree
  },
  created () {
    this.getTeamRole()
    this.getTeamRoleParam()
  },
  activated () {
    this.newcoursestatus = this.newcoursestatus.filter((item) => { return item.name !=='未发布' }) || []
    this.templateNameLinkShowFlg = false
    this.classroomLabelShowFlg = false
    this.courseShowFlg = false

    this.$request.get(`/rm/courseclassroomrela/queryBussinessTypeIdRela`).then((res, total, code, data) => {
      if (data.data != null && data.data != undefined) {
        this.bussinessTypeId = data.data
        this.bussinessTypeChecked = data.data
      }
    })
  },
  methods: {
    // 选择课程
    selectCourse () {
      this.courseSelect = true
      this.$nextTick(() => {
        this.$refs.selCertCourseDialog && this.$refs.selCertCourseDialog.init()
      })
    },
    // 点击选择标签打开弹窗
    showSuboLableDlg () {
      this.isQueryShowLable = true
    },
    //关闭选择标签弹窗
    showQueryLableClose(){
      this.isQueryShowLable = false
    },
    clearclassroomLabelName () {
      this.dataForm.classroomLabel = ''
      this.dataForm.classroomLabelName = ''
      this.checkList = []
      this.classroomLabelShowFlg = false
    },
    classroomLabelShow () {
      this.classroomLabelShowFlg = true
    },
    classroomLabelLeave () {
      this.classroomLabelShowFlg = false
    },
    changeCheckedList (array) {
      this.checkList = array
    },
    onOkLable(){
      let args = this.checkList
      if (args && args !== '' && args.length > 0) {
        let classLabelinfo = []
        let classLabelinfoName = []
        args.forEach(function (item) {
          classLabelinfo.push(item.labelId)
          classLabelinfoName.push(item.labelName)
        })
        this.dataForm.classroomLabel = classLabelinfo.join(',')
        this.dataForm.classroomLabelName = classLabelinfoName.join(',')
      } else {
        this.dataForm.classroomLabel = ''
        this.dataForm.classroomLabelName = ''
      }
      this.isQueryShowLable = false
    },
    // 重置查询条件
    resetQuery () {
      this.dataForm = {
        courseNo: '',
        coursecName: '',
        classroomNo: '',
        classroomName: '',
        classRoomStatus: '',
        courseStatus: '',
        courseClassList: '',
        teamClassList: '',
        classroominfoList: '',
        cityList: '',
        classroomLabel: '',
        classroomLabelName: '',
        classificationList: '',
        courseTeamCatalogFirst: '',
        courseTeamCatalogSecond: '',
        selectCatalogSecond: ''
      }
      this.dataForms = {
        classRoomStatusArr: [],
        courseStatus: [],
        classificationListArr: []
      }
      this.showCourseClassList = []
      this.selectTable = []
      this.$refs.classroomclassRef.resetChecked()
      this.$refs.cityclassRef.resetChecked()
      this.$refs.catalogtreeList.resetChecked()
      this.checkList = []
      this.courseInfoList = []
      // this.$refs.classroomLabelRef.resetChecked()
      this.queryCourse()
    },
    getCourseList (args) {
      if (args && args !== '' && args.length > 0) {
        let courseArr = []
        args.forEach(function (item) {
          courseArr.push(item.id)
        })
        // to string
        this.dataForm.courseClassList = courseArr.join(',')
      } else {
        this.dataForm.courseClassList = ''
      }
    },
    // 课程分类调用树
    cateloglist: function (data) {
      let catalogIdArr = []
      data[0].data.forEach(rows => {
        catalogIdArr.push(rows.catalogId)
      })
      if (catalogIdArr && catalogIdArr.length > 0) {
        this.dataForm.courseClassList = catalogIdArr.join(',')
      } else {
        this.dataForm.courseClassList = ''
      }
    },
    getTeamList (args) {
      if (args && args !== '' && args.length > 0) {
        let tramClass = []
        args.forEach(function (item) {
          tramClass.push(item.id)
        })
        this.dataForm.teamClassList = tramClass.join(',')
      } else {
        this.dataForm.teamClassList = ''
      }
    },
    getClassroomList (args) {
      let classroominfo = []
      args.forEach(function (item) {
        classroominfo.push(item.id)
      })
      this.dataForm.classroominfoList = classroominfo.join(',')
    },
    getCitySelectList (args) {
      if (args && args !== '' && args.length > 0) {
        let citySelect = []
        args.forEach(function (item) {
          citySelect.push(item.id)
        })
        this.dataForm.cityList = citySelect.join(',')
      } else {
        this.dataForm.cityList = ''
      }
    },
    getClassificationList (args) {
      if (args && args !== '' && args.length > 0) {
        let siteClass = []
        args.forEach(function (item) {
          siteClass.push(item.id)
        })
        this.dataForm.classificationList = siteClass.join(',')
      }
    },
    // 获取教室标签
    getClassroomLabelList (args) {
      if (args && args !== '' && args.length > 0) {
        let classroomLabelinfo = []
        args.forEach(function (item) {
          classroomLabelinfo.push(item.id)
        })
        this.dataForm.classroomLabel = classroomLabelinfo.join(',')
      } else {
        this.dataForm.classroomLabel = ''
      }
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    },
    // 状态转换
    statusFormatter (row) {
      return Vue.filter('coverEnum')(row.classStatus, 'status')
    },
    // 课程状态转换
    courseStatusFormatter (row) {
      return Vue.filter('coverEnum')(row.courseStatus, 'courseStatus')
    },
    // 课程团队分类转换
    courseTeamCatalogFormatter (row) {
      var nameFirst = Vue.filter('coverEnum')(row.courseTeamCatalogFirst, 'catalogidList1')
      var nameSecond = Vue.filter('coverEnum')(row.courseTeamCatalogSecond, 'catalogidList2')
      var comma = ''
      if (nameFirst !== null && nameSecond !== null && nameFirst !== '' && nameSecond !== '') {
        comma = ','
      }
      return nameFirst + comma + nameSecond
    },
    queryCourse () {
      this.page = 1
      if (this.dataForms.classRoomStatusArr instanceof Array) {
        this.dataForm.classRoomStatus = this.dataForms.classRoomStatusArr.join(',')
      }
      if (this.dataForms.courseStatusArr instanceof Array) {
        this.dataForm.courseStatus = this.dataForms.courseStatusArr.join(',')
      }
      this.getTeamRoleParam()
      this.getDataList()
    },
    addUpdate (row) {
      let name = 'rm-courseclassroomrela-add-or-update'
      let pkName = (row != null) ? row.id : undefined
      let query = {}
      query.id = pkName
      this.$router.push({
        name: name,
        query: query
      })
      this.$eventHub.$emit('classroomAdd', '')
    },
    Update (row) {
      let name = 'rm-courseclassroomrela-update'
      let query = {}
      query.courseId = row.courseId
      this.$router.push({
        name: name,
        query: query
      })
    },
    editPriority (row) {
      if (this.$hasPermission('AUTHRELACLASSROOM0004')) {
        const params = {
          id: row.id,
          priority: row.priority
        }
        this.$request.get('/rm/courseclassroomrela/updatePriority', params).then(() => {
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500
          })
          this.getDataList()
        })
      }
    },
    courseClassroomRelaDelete (row) {
      this.$confirm(this.$t('prompt.info', { 'handle': this.$t('delete') }), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        let _this = this
        let url = ''
        let param = ''
        url = '/rm/courseclassroomrela/deleteCourseClassroomList'
        param = {
          ids: row.id
        }
        _this.$request.get(
          url, param
        ).then((data) => {
          _this.$message({
            message: _this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.getDataList()
            }
          })
        })
      })
    },
    // 批量删除
    BatchDeletion () {
      let _this = this
      let selectList = this.$refs.selectCourseinfo.selection
      let selectArr = []
      if (selectList.length <= 0) {
        // errmessage不明
        this.$message.warning(this.$t('prompt.deleteBatch'))
        return false
      }
      for (var i in selectList) {
        selectArr.push(selectList[i].id)
      }
      this.$confirm(this.$t('prompt.info', { 'handle': this.$t('delete') }), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        let url = '/rm/courseclassroomrela/deleteCourseClassroomList'
        let param = {
          ids: selectArr.join(',')
        }
        _this.$request.get(
          url, param
        ).then((data) => {
          _this.$message({
            message: _this.$t('prompt.success'),
            type: 'success',
            duration: 500
          })
          _this.getDataList()
        })
      })
    },
    // 模板下载
    exportAnnualTarget () {
      // download 参数 url, params, 报表名
      // this.$request.download('/rm/courseclassroomrela/exportTemple', this.$t('res.courseclassroomrela.courseclassroomrelaExcelTemple'), {})
      this.$request.download('/rm/file/downtemplate', this.$t('res.courseclassroomrela.courseclassroomrelaExcelTemple'), {fileName: 'course_classroom_temple.xlsx'},'', 'xlsx')
    },
    // 关系信息导入
    importRelaDialog () {
      this.importDialog = true
    },
    // 关闭导入弹框
    closeDialogImport () {
      this.importDialog = false
      this.page = 1
      if (this.dataForms.classRoomStatusArr instanceof Array) {
        this.dataForm.classRoomStatus = this.dataForms.classRoomStatusArr.join(',')
      }
      if (this.dataForms.courseStatusArr instanceof Array) {
        this.dataForm.courseStatus = this.dataForms.courseStatusArr.join(',')
      }
      if (this.dataForms.classificationListArr instanceof Array) {
        this.dataForm.classificationList = this.dataForms.classificationListArr.join(',')
      }
      this.getDataList()
    },
    // 批量导出
    columnBtn () {
      if (this.dataForms.classRoomStatusArr instanceof Array) {
        this.dataForm.classRoomStatus = this.dataForms.classRoomStatusArr.join(',')
      }
      if (this.dataForms.courseStatusArr instanceof Array) {
        this.dataForm.courseStatus = this.dataForms.courseStatusArr.join(',')
      }
      if (this.dataForms.classificationListArr instanceof Array) {
        this.dataForm.classificationList = this.dataForms.classificationListArr.join(',')
      }
      // download 参数 url, params, 报表名
      this.$request.downloadRm('/rm/courseclassroomrela/export', this.$t('res.courseclassroomrela.courseclassroomrelaExcel'),
        {
          ...this.dataForm
        }
      )
    },
    // 关闭所属场地
    closeSuboSiteDlg () {
      this.isShowSuboSite = false
    },
    // 点击所属场地确定带回
    bringBack (selection) {
      let siteNames = []
      let siteIds = []
      selection.forEach(item => {
        siteNames.push(item.siteCnName)
        siteIds.push(item.id)
      })
      if (selection && selection.length > 0) {
        this.dataForm.classificationList = siteIds.join(',')
        this.dataForm.subordinateSiteName = siteNames.join(',')
      } else {
        this.dataForm.classificationList = ''
        this.dataForm.subordinateSiteName = ''
      }
      this.isShowSuboSite = false
      this.selectTable = selection
    },
    celarSiteName () {
      this.selectTable = []
      this.dataForm.classificationList = ''
      this.dataForm.subordinateSiteName = ''
    },
    // 点击所属场地打开弹窗
    showSuboSiteDlg () {
      this.isShowSuboSite = true
      this.$refs.suborSiteRef.initSuborSite()
    },
    clearSuboSiteDlg () {
      this.dataForm.classificationList = ''
    },
    // 课程团队分类二级菜单取得
    getcourseTeamCatalog (prov) {
      let tempArry = []
      this.select2 = []
      if (this.dataForm.selectCatalogSecond !== null || this.dataForm.selectCatalogSecond === '') {
        this.dataForm.selectCatalogSecond = ''
      }
      for (var val of this.allteamcatalog) {
        var code = val.code.slice(0, 2)
        if (prov === code) {
          tempArry.push({ name: val.name, code: val.code })
        }
        this.select2 = tempArry
      }
    },
    getList (opt) {
      console.log(opt)
    },
    clearTemplateName () {
      this.selectTable = []
      this.dataForm.classificationList = ''
      this.dataForm.subordinateSiteName = ''
      this.templateNameLinkShowFlg = false
    },
    templateNameLinkShow () {
      this.templateNameLinkShowFlg = true
    },
    templateNameLinkLeave () {
      this.templateNameLinkShowFlg = false
    },
    checkLable(row){
      this.isShowLable = true
      this.$request.get(`/rm/courseclassroomrela/queryCheckedCommLabel/${row.classroomId}/${this.bussinessTypeId}`).then((data) => {
        // 已选择的标签
        this.showcheckList = data ? data : []
        // 特殊情况，自己国际化
        const language = VueI18n.locale
        if (language === 'zh-CN') {
          this.showcheckList.forEach(o => {
            o.labelName = o.labelNameCn
          })
        } else {
          this.showcheckList.forEach(o => {
            o.labelName = o.labelNameEn
          })
        }
      })
    },
    showLableClose(){
      this.showcheckList = []
      this.isShowLable = false
    },
    getBussinessType (val) {
      this.bussinessTypeId = val
    },
    changeShowCheckedList (array) {
      this.showcheckList = array
    },
    // 重新勾选业务标签
    fatherMethod () {
      // this.checkList = []
      // 已选择的标签
      // this.checkList = this.dataForm.commLabelVoList ? this.dataForm.commLabelVoList : []
      // 特殊情况，自己国际化
      const language = VueI18n.locale
      if (language === 'zh-CN') {
        this.checkList.forEach(o => {
          o.labelName = o.labelNameCn
        })
      } else {
        this.checkList.forEach(o => {
          o.labelName = o.labelNameEn
        })
      }
    },
    // 课程选择完成
    couronOk: function (data) {
      let _this = this
      _this.courseInfoList = []
      data.forEach(row => {
        _this.courseInfoList.push(row)
      })
      if (_this.courseInfoList && _this.courseInfoList.length > 0) {
        let courseName = []
        let courseCode = []
        _this.courseInfoList.forEach(row => {
          courseName.push(row.courseNameCn)
          courseCode.push(row.courseCode)
        })
        this.dataForm.coursecName = courseName.join(',')
        this.dataForm.courseNo = courseCode.join(',')
      } else {
        this.dataForm.coursecName = ''
        this.dataForm.courseNo = ''
      }
      this.courseSelect = false
    },
    closeFun () {
      this.courseSelect = false
    },
    courseShow () {
      this.courseShowFlg = true
    },
    courseLeave () {
      this.courseShowFlg = false
    },
    celarCourseName () {
      this.dataForm.coursecName = ''
      this.dataForm.courseNo = ''
      this.courseInfoList = []
      this.courseShowFlg = false
    },
    getTeamRole () {
      // 课程团队分类二级
      for (let val of this.teamcatalogsecond) {
        if (this.$hasPermission(this.teamPerms + ':'+ val.code)) {
          this.allteamcatalog.push(val)
        }
      }
      if (this.allteamcatalog.length === 0) {
        this.isteamPerm = false
        this.allteamcatalog = this.teamcatalogsecond
      }
      // 课程团队分类一级
      let tempArry = []
      for (let val of this.allteamcatalog) {
        var code = val.code.slice(0, 2)
        if (tempArry.indexOf(code) === -1) {
          tempArry.push(code)
        }
      }
      for (let val of this.teamcatalogfirst) {
        if (tempArry.indexOf(val.code) !== -1) {
          this.select1.push(val)
        }
      }
      if (this.select1.length === 0) {
        this.select1 = this.teamcatalogfirst
      }
    },
    getTeamRoleParam () {
      this.dataForm.courseTeamCatalogSecond = this.dataForm.selectCatalogSecond
      if ((this.dataForm.courseTeamCatalogSecond === null || this.dataForm.courseTeamCatalogSecond === '') && this.isteamPerm) {
        // 课程团队分类二级
        let tempArry = []
        for (let val of this.allteamcatalog) {
          tempArry.push(val.code)
        }
        if (tempArry.length > 0) {
          this.dataForm.courseTeamCatalogSecond = tempArry.join(',')
        }
      }
    }
  }
}
</script>

<style scoped>
@import "../../css/pkg-styles.css";
.postion {
  color: blue;
}
.postion:hover {
  outline: none;
  border-bottom: 1px solid blue;
}
.link-type,
.link-type:focus {
  color: #337ab7;
  cursor: pointer;
}
.link-type:hover {
  color: rgb(32, 160, 255);
}
.link-delete-temp:hover{
  cursor: pointer;
  text-decoration: none !important;
}
.holder:empty::before{
  color:#bbb;
  content:attr(placeholder);
}
.course-update-button {
  padding: 8px 20px !important;
  border-left: none !important;
}
/* 
.pkg-search-condition .el-col .el-form-item .el-form-item__content{
  margin-left: 100px;
} */

</style>
<style>
.pkg-search-condition .el-form-item__content {
  margin-left: 96px !important;
}
.one-course .el-form-item__label-wrap, .tow-classroom .el-form-item__label-wrap {
  margin-left: 30px !important;
}
.one-sortingclasses .el-form-item__label-wrap, .two-sortingclassroom .el-form-item__label-wrap, .three-city .el-form-item__label-wrap {
  margin-left: 0px !important;
}
.one-courseteamclassification-div .el-form-item__content, .two-classstatus .el-form-item__content, .three-venue .el-form-item__content {
  margin-left: 130px !important;
}
.two-classstatus, .three-venue {
  width: 88% !important;
}
.three-classroomstatus .el-form-item__label-wrap, .four-classroomlabel .el-form-item__label-wrap {
  margin-left: 2px !important;
}
</style>